export const ROLES = {
  STAFF: "staff",
  OWNER: "owner",
  MANAGER: "manager",
};
